import { FlagShipModificationValues } from '@abtasty/api-client';

import { useAccountData } from '../shared/tag/context/useTagData';

export const useAccountId = (): number | undefined => {
  const { accountId } = useAccountData();

  return accountId;
};

export const useFlagshipActivation = (...keys: (keyof FlagShipModificationValues | string)[]) => {
  const { flagship: flags } = useAccountData();

  return keys.map<boolean>((k) => flags[k]);
};

export function useForceTargeting() {
  const [hasForceTargetingAccess] = useFlagshipActivation('qaa_force_targeting');
  return hasForceTargetingAccess;
}
